var utils = require( './utils' );

var sidebar_menu = ( function( $ ) {

	var $left_side;
	var $sidebar_container;

	var $sidebar = null;

	var _init = function() {
		$left_side         = $( '.left-side' );
		$sidebar           = $( '#sidebar-menu' );
		$sidebar_container = $( ' #sidebar-container' );

		if ( utils.viewport_size().width < 992 ) {
			$sidebar.find( '.header' ).on( 'click', _open_menu );
		} else {
			$( document ).on( 'setup_sidebar_scroll', setup_scroll_to_fixed );
		}

		if ( utils.viewport_size().width >= 992 && $left_side.outerHeight() > $sidebar_container.outerHeight() ) {
			setup_scroll_to_fixed();
		} else if ( utils.viewport_size().width >= 992 ) {
			$left_side.css( 'min-height', $sidebar_container.outerHeight() );
		}

		_setup_submenus();
	};

	var setup_scroll_to_fixed = function( $sidebar ) {
		if ( ! $sidebar ) {
			$sidebar = $( '#sidebar-menu' );
		}

		set_sidebar_container_height();
		$sidebar.stick_in_parent();
	};

	var _set_sidebar_container_height = function() {
		if ( utils.viewport_size().width >= 992 ) {
			if ( $left_side.outerHeight() >= $sidebar_container.outerHeight() ) {
				$sidebar_container.height( $left_side.outerHeight() );
			} else  {
				$sidebar_container.height( 'auto' );
			}
		}

		$left_side.height( 'auto' );
	};

	var set_sidebar_container_height = function() {
		$left_side         = $( '.left-side' );
		$sidebar_container = $( ' #sidebar-container' );

		_set_sidebar_container_height();
	};

	var _open_menu = function( event ) {
		$sidebar.toggleClass( 'expanded' );
		$sidebar.find( '.menu-container' ).slideToggle();

		event.preventDefault();
	};

	var _setup_submenus = function() {
		var $menu = $sidebar.find( '.menu-container .menu' ) ;

		if ( $menu.length <= 0 && $menu.find( 'li.menu-item-has-children' ) <= 0 ) {
			return;
		}

		$menu.find( 'li.menu-item-has-children > a' ).on( 'click', function( e ) {

			if ( utils.viewport_size().width < 992 ) {
				e.preventDefault();

				_toggle_submenu( $( this ).closest( 'li.menu-item-has-children' ).find( 'ul.sub-menu' ) );
			}
		} );
	};

	var _toggle_submenu = function( $submenu ) {
		var $parent = $submenu.closest( 'li.menu-item-has-children' );

		if ( ! $parent.hasClass( 'expanded' ) ) {
			$parent.addClass( 'expanded' );
			$submenu.slideDown();
		} else {
			$parent.removeClass( 'expanded' );
			$submenu.slideUp();
		}
	};

	if( $( '#sidebar-menu' ).length > 0  ) {
		$( window ).load( _init );
	}

	return {
		set_sidebar_container_height: set_sidebar_container_height,
		setup_scroll_to_fixed: setup_scroll_to_fixed
	}

} ) ( jQuery );

module.exports = sidebar_menu;